import React from 'react'
import styled from 'styled-components'

const LoisCheckout = styled.div`
    padding: 2rem;
    background: ${p => p.theme.low};
    border-radius: var(--smallRadius);
    text-align: center;
    
    img{
        width: 15rem;
        margin-bottom: 2rem;
    }
`

export default function CRM_Checkout(props) {

  return (
    <LoisCheckout>
        <img src="https://genius1071.friktoriaservers.net/doitforme/morning/app/icons/light/NifflerLight.svg" alt="CRM" />
        <h2>CRM</h2>
        <h5>Doitforme</h5>
    </LoisCheckout>
  )
}
